import { FIELD_TYPES } from "../../../libs/formdatavalidator/constants";

export const BOI_FORM_STEPS = {
    BENEFICIAL_OWNER : "BenificialOwner",
    REPORTING_COMPANY : "ReportingCompany",   
    COMPANY_APPLICATION : "CompanyApplication", 
    FILING_INFO: "FilingInfo",         
    SUBMIT: "Submit", 
}

export const BOI_FORM_STATUS = {
    NOT_SUBMITTED : "Not submitted",
    SUBMITTED : "Submitted",
    RESUBMIT : "Resubmit",
    ACCEPTED : "IRS Accepted",
    BLOCKED : "Blocked",
}

export const BOI_FORM_STATUS_OPTIONS = [
    {label: BOI_FORM_STATUS.NOT_SUBMITTED, value: BOI_FORM_STATUS.NOT_SUBMITTED},
    {label: BOI_FORM_STATUS.SUBMITTED, value: BOI_FORM_STATUS.SUBMITTED},
    {label: BOI_FORM_STATUS.RESUBMIT, value: BOI_FORM_STATUS.RESUBMIT},
    {label: BOI_FORM_STATUS.ACCEPTED, value: BOI_FORM_STATUS.ACCEPTED},
    {label: BOI_FORM_STATUS.BLOCKED, value: BOI_FORM_STATUS.BLOCKED},
]

export const IGNORE_FIELDS = ["FormName", "FormRecordId", "PayerDetailId", "decryptedFormRecordId", "RecipentDetailId", "BeneficialOwnerDetailsId"];

export const HIDE_LABELS_FOR_FIELD_TYPES = [FIELD_TYPES.BOOLEAN, FIELD_TYPES.BUTTON, FIELD_TYPES.FILE_UPLOAD]

export const BOI_SINGLE_FILING_FEE_AMOUNT = 45;
export const BOI_SUBSCRIPTION_FILING_FEE_AMOUNT = 175;

export const PRE_FILLED_FIELDS_MAP = {
    reportingCompany: {
        "RptCompLglName": "LastName",
        "AlternateName": "DisregardedEntity",
        "FormTaxIdentificationType": "IdType",
        "FormTaxIdnumber": "IdNumber",
        "FormCountry": "Country",
    },
    benefiaryOwner: {
        "BeneficialApplicantLastName": "LastName",
        "BeneficialApplicantFirstName": "FirstName",
        "BeneficialApplicantMiddleName": "MiddleName",
        "BeneficialApplicantSuffix": "Suffix",
        "BeneficialApplicantDateofBirth": "",
        "ResidentialAddress": "Address1",
        "ResidentialCity": "City",
        "ResidentialCountry": "Country",
        "ResidentialState": "State",
        "ResidentialZip": "ZipCode",
    },
    submit: {
        "SubmitEmail": "Email",
        "ConfirmEmail": "Email",
        "FirstName": "FirstName",
        "LastName": "LastName",
    }
}

export const MANAGE_BOI_LOADING_STATES = {
    MANAGE_BOI_FORMS_PAGE_LOADING: "MANAGE_BOI_FORMS_PAGE_LOADING",
    MANAGE_BOI_FORMS_PAGE_READY: "MANAGE_BOI_FORMS_PAGE_READY",
    GRID_LOADING: "GRID_LOADING",
    GRID_READY: "GRID_READY",
    VIEW_PDF_LOADING: "VIEW_PDF_LOADING",
    VIEW_PDF_READY: "VIEW_PDF_READY",
    PAYERS_LIST_LOADING: "PAYERS_LIST_LOADING",
    PAYERS_LIST_READY: "PAYERS_LIST_READY",
}

export const MANAGE_BOI_LOADING_STATES_MESSAGE_MAP = {
    [MANAGE_BOI_LOADING_STATES.MANAGE_BOI_FORMS_PAGE_LOADING]: "",
    [MANAGE_BOI_LOADING_STATES.GRID_LOADING]: "",
    [MANAGE_BOI_LOADING_STATES.PAYERS_LIST_LOADING]: "",
}

export const FILE_BOI_LOADING_STATES = {
    REPORTING_COMPANY_GRID_LOADING: "REPORTING_COMPANY_GRID_LOADING",
    REPORTING_COMPANY_GRID_READY: "REPORTING_COMPANY_GRID_READY",
    BENEFICIARY_OWNERS_GRID_LOADING: "BENEFICIARY_OWNERS_GRID_LOADING",
    BENEFICIARY_OWNERS_GRID_READY: "BENEFICIARY_OWNERS_GRID_READY",
    BENEFICIARY_OWNERS_REQUEST_EMAIL_LOADING: "BENEFICIARY_OWNERS_REQUEST_EMAIL_LOADING",
    BENEFICIARY_OWNERS_REQUEST_EMAIL_READY: "BENEFICIARY_OWNERS_REQUEST_EMAIL_READY",
    FILE_BOI_MAIN_LOADING: "FILE_BOI_MAIN_LOADING",
    FILE_BOI_MAIN_READY: "FILE_BOI_MAIN_READY",
    CALCULATE_INFERRED_LOADING: "CALCULATE_INFERRED_LOADING",
    CALCULATE_INFERRED_READY: "CALCULATE_INFERRED_READY",
    SAVE_STEP_LOADING: "SAVE_STEP_LOADING",
    SAVE_STEP_READY: "SAVE_STEP_READY",
    REPORTING_COMPANY_DETAILS_LOADING: "REPORTING_COMPANY_DETAILS_LOADING",
    REPORTING_COMPANY_DETAILS_READY: "REPORTING_COMPANY_DETAILS_READY",
    GET_REVIEW_DETAILS_LOADING: "GET_REVIEW_DETAILS_LOADING",
    GET_REVIEW_DETAILS_READY: "GET_REVIEW_DETAILS_READY",
}

export const FILE_BOI_LOADING_STATES_MESSAGE_MAP = {
    [FILE_BOI_LOADING_STATES.REPORTING_COMPANY_GRID_LOADING]: "",
    [FILE_BOI_LOADING_STATES.BENEFICIARY_OWNERS_GRID_LOADING]: "",
    [FILE_BOI_LOADING_STATES.BENEFICIARY_OWNERS_REQUEST_EMAIL_LOADING]: "",
    [FILE_BOI_LOADING_STATES.FILE_BOI_MAIN_LOADING]: "",
    [FILE_BOI_LOADING_STATES.CALCULATE_INFERRED_LOADING]: "",
    [FILE_BOI_LOADING_STATES.SAVE_STEP_LOADING]: "",
    [FILE_BOI_LOADING_STATES.REPORTING_COMPANY_DETAILS_LOADING]: "",
    [FILE_BOI_LOADING_STATES.GET_REVIEW_DETAILS_LOADING]: "",
}

export const BOI_QUERY_PARAMS = {
    STATUS: "status",
    REPORTING_COMPANY: "reportingcompany",
};

export const COMPANY_APPLICANT_ID_FIELD_NAME = "CompanyApplicantId";
export const PAYER_DETAIL_ID_FIELD_NAME = "PayerDetailId";
export const IS_BENEFICIAL_SELECT_ALL_SELECTED = "isBeneficialSelectAllSelected";